import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ClickableTextProps {
  text: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export function ClickableText({
  text,
  onClick,
  disabled = false,
  className,
}: ClickableTextProps) {
  return (
    <span
      onClick={!disabled ? onClick : undefined}
      className={cn(
        "select-none",
        disabled
          ? "cursor-not-allowed text-gray-500"
          : "cursor-pointer text-slate-600 hover:text-slate-700",
        className,
      )}
    >
      {text}
    </span>
  );
}
